var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"display":"grid","grid-auto-flow":"column","grid-gap":"8px","grid-auto-columns":"min-content"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }